export default {
      id: "oc-auto-set-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-auto-set",
      toString: function () {
        return this.url;
      }
    }